export default class ItemFormularioCampo {
    Descripcion: string;
    NombreCampo: string;
    DescripcionCampo: string;
    Tipo: string;
    Orden: number;
    Consulta: string;
    Solo_lectura: boolean;

    constructor() {
        this.Descripcion = "";
        this.NombreCampo = "";
        this.DescripcionCampo = "";
        this.Tipo = "";
        this.Orden = 0;
        this.Consulta = "";
        this.Solo_lectura = false;
    };
};
